module.exports = __webpack_public_path__ + "img/20191022_122337.7491e0a5.jpg";